import React, { createContext, useState, useEffect, useCallback, useMemo } from 'react'

import api from '../services/api'


export const CustomerContext = createContext({})

function CustomerProvider({ children }) {

  const [customer, setCustomer] = useState(JSON.parse(localStorage.getItem("customer")) || {})

  useEffect(() => {
    localStorage.setItem('customer', JSON.stringify(customer))

  }, [customer])

  const getCustomer = useCallback(async (data) => {

    try {

      const response = await api.post('customer', data)

      if (response?.data?.id) {

        setCustomer(response.data)

        return response?.data?.id ? true : false

      } else {

        if (JSON.parse(localStorage.getItem("customer"))) {
          localStorage.removeItem("customer")
        }

        return false
      }

    } catch (error) {

      if (JSON.parse(localStorage.getItem("customer"))) {
        localStorage.removeItem("customer")
      }

      if (error.response) {
        console.log(error.response.data.error)
        alert(error.response.data.error)
      } else {
        console.log(error.message)
        alert(error.message)
      }


      return false
    }

  }, [])

  const registerCustomer = useCallback(async (data, business_id) => {

    try {

      const response = await api.post(`customers_local/businesses/${business_id}`, data)

      if (response?.data?.id) {
        setCustomer(response?.data)
      }

    } catch (error) {      
       if (error.response) {
        console.log(error.response.data.error)
        alert(error.response.data.error)
      } else {
        console.log(error.message)
        alert(error.message)
      }
      
    }

  }, [])

  const value = useMemo(
    () => ({ customer, getCustomer, registerCustomer }),
    [customer, getCustomer, registerCustomer]
  )

  return (
    <CustomerContext.Provider value={value}>
      {children}
    </CustomerContext.Provider>
  )
}

export default CustomerProvider